import { authClient, userHasRole } from '@/lib/auth-client.ts';
import type { ReactNode } from 'react';

export default function RoleRequired({
  role,
  children,
}: {
  role: string;
  children: ReactNode;
}) {
  const session = authClient.useSession();

  if (session.isPending) return null;

  return userHasRole(session.data?.user, role) ? children : null;
}
